import toast from 'react-hot-toast';
import { MAX_FILE_SIZE_BYTES, THEME } from './constants';

export const validateFileSize = (file: File): boolean => {
  return file.size <= MAX_FILE_SIZE_BYTES;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const validateCoordinates = (
  lat: string,
  lng: string,
): { valid: boolean; error?: string } => {
  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);

  if (isNaN(latNum) || isNaN(lngNum)) {
    return { valid: false, error: 'Invalid coordinates. Please enter valid numbers.' };
  }

  if (latNum < -90 || latNum > 90) {
    return { valid: false, error: 'Latitude must be between -90 and 90.' };
  }

  if (lngNum < -180 || lngNum > 180) {
    return { valid: false, error: 'Longitude must be between -180 and 180.' };
  }

  return { valid: true };
};

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const showErrorToast = (message: string) => {
  toast.error(message, {
    style: {
      background: THEME.background,
      color: THEME.text,
      borderColor: THEME.primary,
    },
  });
};

export const showSuccessToast = (message: string) => {
  toast.success(message, {
    style: {
      background: THEME.background,
      color: THEME.text,
      borderColor: THEME.primary,
    },
  });
};
